/* globals $ App Craft */

import getBrowserLanguage from "get-browser-language";

class languagePopup {
  constructor() {
    this.$elem = $("#language-popup");
    this.original = this.$elem.find("#language-popup-list").html();
    this.$open = $(".js-open-language-popup");
    this.$close = this.$elem.find(".js-close");
    this.init();
    if (!App.cookies.getCookie("current-site-closed") && !App.cookies.getCookie("current-site")) {
      this.showPopup();
    }
  }

  init() {
    this.$open.click((e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openPopup();
    });

    this.$close.click((e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closePopup();
    });

    $(document).on("keydown", (e) => {
      if (e.key == "Escape") {
        this.closePopup(e);
      }
    });

    this.$elem.find("a.js-change-site").click((e) => {
      e.preventDefault();
      let $link = $(e.currentTarget);
      if (Craft.currentSite.groupUid != Craft.globalGroupUid) {
        App.cookies.setCookie("current-site", $link.data("id"));
      }
      window.location.href = $link.attr("href");
    });
  }

  loadLanguages(groupId) {
    return $.ajax({
      url: Craft.currentSite.baseUrl + "ajax/language-list",
      data: {
        groupId: groupId,
        entryId: $("body").data("id"),
      },
    }).done((response) => {
      this.$elem.find("#language-popup-list").html(response);
      this.openPopup();
    });
  }

  openPopup() {
    this.$elem.fadeIn("fast");
    App.disableBodyScroll();
  }

  closePopup() {
    this.$elem.fadeOut("fast", () => {
      this.$elem.find("#language-popup-list").html(this.original);
    });
    if (!$("#mob-menu").is(":visible")) {
      App.enableBodyScroll();
    }
    App.cookies.setCookie("current-site-closed", 1);
  }

  showPopup() {
    try {
      let lang = getBrowserLanguage().split("-")[0];
      let currentLang = Craft.currentSite.lang.split("-")[0];
      if (lang != currentLang) {
        this.openPopup();
      }
    } catch (error) {
      console.warn("Unable to figure out your language");
    }
  }
}

export { languagePopup };
